import { graphql, useStaticQuery } from 'gatsby'
import { object } from 'prop-types'
import React, { createContext, useEffect } from 'react'

export const StrategyOverviewCardsContext = createContext({})

const StrategyOverviewCardsProvider = ({ children }) => {
  const [overviewCards, setOverviewCards] = React.useState([])
  const {
    allContentfulStrategyBuilderOverviewCardV2: overviewCardsData,
  } = useStaticQuery(GET_ALL_OVERVIEW_CARDS)

  useEffect(() => {
    if (overviewCards) {
      //sort list by rank
      overviewCardsData?.nodes?.sort(function (a, b) {
        return a.rank - b.rank
      })
      setOverviewCards(overviewCardsData.nodes)
    }
  }, [overviewCardsData])

  return (
    <StrategyOverviewCardsContext.Provider
      value={{
        overviewCards,
      }}
    >
      {children}
    </StrategyOverviewCardsContext.Provider>
  )
}

StrategyOverviewCardsProvider.propTypes = {
  children: object.isRequired,
}

const GET_ALL_OVERVIEW_CARDS = graphql`
  {
    allContentfulStrategyBuilderOverviewCardV2 {
      nodes {
        rank
        deliverableDownloadText
        deliverableLockedText
        description {
          raw
        }
        descriptionAfterCompletion
        destinationUrl
        id
        isOptional
        isSummary
        marketingObjects {
          title
          icon {
            file {
              url
            }
          }
          answerText
        }
        title
        titleAfterCompletion
        icon {
          file {
            url
          }
        }
      }
    }
  }
`

export default StrategyOverviewCardsProvider
